import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

// Get the API base URL from environment or use default
// In production, we use relative URLs since nginx proxies /graphql
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

// HTTP connection to the API
const httpLink = createHttpLink({
  uri: `${API_BASE_URL}/graphql`,
  credentials: 'include', // Important for cookies, authorization headers with HTTPS
});

// Auth link to add token to requests
const authLink = setContext((_, { headers }) => {
  // Get the authentication token from local storage if it exists
  const token = localStorage.getItem('authToken'); // Changed from 'token' to 'authToken' to match apiClient
  
  // Return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  };
});

// Create the Apollo Client instance
export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          reconciliationStatus: {
            merge: false, // Always replace with fresh data
          },
          reconciliationHistory: {
            merge: false, // Always replace with fresh data
          },
          reconciliationMetrics: {
            merge: false, // Always replace with fresh data
          },
        },
      },
    },
  }),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
});